// Copyright (c) 2023 Deere & Company

import DuplicatePinFormValidation from '../state/duplicate-pin-form-validation';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateFormValidity = (state, action) =>
DuplicatePinFormValidation.update(state, {
    [action.property]: {
        $set: action.validity
    }
});

const resetFormValidation = () => getDefaultState().formValidation;

export default (state = getDefaultState().formValidation, action) => {

    const actionTypes = {
        [actions.RESET_DUPLICATE_PIN_PLATE_FORM_VALIDATION]: resetFormValidation,
        [actions.UPDATE_DUPLICATE_PIN_PLATE_FORM_VALIDATION]: updateFormValidity
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/duplicate-pin-plate/reducers/form-validation.js